import React, { useEffect, createElement } from 'react';
import { CheckCircle2, Calendar, Clock, AlertCircle, ArrowRight, XCircle, Check } from 'lucide-react';
export function ConfirmationPage() {
  useEffect(() => {
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    // Load Wistia embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/8o83yr3ec3.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia styles
    const style = document.createElement('style');
    style.textContent = `wistia-player[media-id='8o83yr3ec3']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/8o83yr3ec3/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(style);
    // Meta Pixel Code
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Purchase');
    // Add noscript fallback image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=754551913878347&ev=Purchase&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-indigo-100 selection:text-indigo-900" data-id="element-2">
      {/* Progress Bar / Top Indicator */}
      <div className="w-full bg-slate-50 border-b border-slate-200" data-id="element-3">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between text-sm font-medium text-slate-500" data-id="element-4">
          <div className="flex items-center gap-2 text-emerald-600" data-id="element-5">
            <CheckCircle2 className="w-5 h-5" data-id="element-6" />
            <span data-id="element-7">Compra Exitosa</span>
          </div>
          <div className="flex items-center gap-2 text-indigo-600" data-id="element-8">
            <span className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center text-xs font-bold" data-id="element-9">
              2
            </span>
            <span data-id="element-10">Siguiente: Implementación</span>
          </div>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-6 py-12 md:py-16 space-y-16" data-id="element-11">
        {/* HERO SECTION */}
        <section className="text-center space-y-8" data-id="element-12">
          <div className="space-y-4" data-id="element-13">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900" data-id="element-14">
              Pago confirmado. <br data-id="element-15" />
              <span className="text-slate-500" data-id="element-16">Paso 1 completado.</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-17">
              Ya tienes acceso al sistema. Ahora vamos a asegurarnos de que lo
              implementes correctamente y sin perder tiempo.
            </p>
          </div>

          {/* VIDEO EMBED */}
          <div className="max-w-4xl mx-auto space-y-6" data-id="element-18">
            <wistia-player media-id="8o83yr3ec3" aspect="1.7777777777777777" data-id="element-19"></wistia-player>

            <a href="https://link.funnelmonkey.com/widget/bookings/info-commerce-strategy-call" target="_blank" rel="noopener noreferrer" className="group relative flex items-center justify-center gap-3 bg-indigo-600 hover:bg-indigo-500 text-white text-lg font-bold py-5 px-8 rounded-xl transition-all duration-200 w-full shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-20">
              AGENDAR LLAMADA DE IMPLEMENTACIÓN
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-21" />
            </a>
          </div>
        </section>

        {/* VALIDATION SECTION */}
        <section className="bg-amber-50 border border-amber-100 rounded-xl p-8 md:p-10" data-id="element-22">
          <div className="flex gap-4 items-start" data-id="element-23">
            <AlertCircle className="w-6 h-6 text-amber-600 shrink-0 mt-1" data-id="element-24" />
            <div className="space-y-4" data-id="element-25">
              <h2 className="text-xl font-bold text-amber-900" data-id="element-26">
                Muy importante que leas esto:
              </h2>
              <p className="text-amber-800 leading-relaxed" data-id="element-27">
                La mayoría de las personas que compran un programa se quedan
                solas tratando de entender qué hacer primero, qué es prioridad y
                si lo están haciendo bien.
              </p>
              <p className="text-amber-800 font-medium" data-id="element-28">
                Por eso, el siguiente paso recomendado es una llamada corta de
                implementación.
              </p>
            </div>
          </div>
        </section>

        {/* CALL EXPLANATION */}
        <section className="space-y-8" data-id="element-29">
          <div className="text-center" data-id="element-30">
            <h2 className="text-3xl font-bold text-slate-900" data-id="element-31">
              Llamada de Implementación
            </h2>
            <p className="text-slate-500 mt-2 font-medium uppercase tracking-wide text-sm" data-id="element-32">
              ¿Qué puedes esperar?
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-33">
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-34">
              <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-35">
                <XCircle className="w-5 h-5 text-rose-500" data-id="element-36" />
                Lo que NO es
              </h3>
              <p className="text-slate-600" data-id="element-37">
                Esta{' '}
                <strong className="text-slate-900" data-id="element-38">
                  NO es una llamada de ventas
                </strong>
                . No intentaremos venderte nada que no necesites ni presionarte.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm" data-id="element-39">
              <h3 className="font-bold text-lg mb-4 flex items-center gap-2 text-indigo-600" data-id="element-40">
                <Check className="w-5 h-5" data-id="element-41" />
                Lo que SÍ haremos
              </h3>
              <ul className="space-y-3" data-id="element-42">
                {['Revisar tu idea a fondo', 'Aclarar el plan correcto para tu caso', 'Evitar errores comunes de principiante', 'Ver si tiene sentido acompañarte'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-43">
                    <span className="w-1.5 h-1.5 bg-indigo-600 rounded-full mt-2 shrink-0" data-id="element-44" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="text-center text-slate-600 italic" data-id="element-45">
            "Incluso si decides hacerlo solo, te vas a llevar claridad
            absoluta."
          </p>
        </section>

        {/* SELF QUALIFICATION */}
        <section className="border-t border-slate-100 pt-12" data-id="element-46">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center" data-id="element-47">
            Esta llamada es ideal si:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-48">
            {['Quieres avanzar más rápido', 'No quieres adivinar si lo estás haciendo bien', 'Prefieres claridad antes que prueba y error', 'Sabes que solo tardarías más sin ayuda'].map((item, i) => <div key={i} className="flex items-center gap-3 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-49">
                <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" data-id="element-50" />
                <span className="text-slate-700 font-medium" data-id="element-51">{item}</span>
              </div>)}
          </div>
          <p className="text-center mt-6 text-slate-600" data-id="element-52">
            Si eres de los que ejecuta mejor con feedback, esta llamada es para
            ti.
          </p>
        </section>

        {/* CTA SECTION */}
        <section className="bg-slate-900 text-white rounded-2xl p-8 md:p-12 text-center space-y-8 shadow-xl" data-id="element-53">
          <div className="space-y-2" data-id="element-54">
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-55">
              Agenda tu llamada de implementación ahora
            </h2>
            <p className="text-slate-400" data-id="element-56">(Los espacios son limitados)</p>
          </div>

          <a href="https://link.funnelmonkey.com/widget/bookings/info-commerce-strategy-call" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 bg-indigo-600 hover:bg-indigo-500 text-white text-lg font-bold py-4 px-8 rounded-xl transition-all duration-200 w-full md:w-auto shadow-lg shadow-indigo-900/50 hover:shadow-indigo-900/70 hover:-translate-y-0.5" data-id="element-57">
            AGENDAR LLAMADA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-58" />
          </a>

          {/* EXPECTATIONS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8 border-t border-slate-800 text-sm text-slate-300" data-id="element-59">
            <div className="flex flex-col items-center gap-2" data-id="element-60">
              <Clock className="w-5 h-5 text-indigo-400" data-id="element-61" />
              <span data-id="element-62">Duración: 20–30 minutos</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-63">
              <Check className="w-5 h-5 text-indigo-400" data-id="element-64" />
              <span data-id="element-65">No es obligatoria</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-66">
              <AlertCircle className="w-5 h-5 text-indigo-400" data-id="element-67" />
              <span data-id="element-68">Sin presión de venta</span>
            </div>
          </div>

          <p className="text-slate-400 text-sm" data-id="element-69">
            Si no es un buen fit, te lo diremos. Nuestro objetivo es ayudarte a
            avanzar.
          </p>
        </section>

        {/* CLOSING */}
        <section className="text-center space-y-6 max-w-xl mx-auto pb-12" data-id="element-70">
          <div className="w-16 h-1 bg-slate-200 mx-auto rounded-full" data-id="element-71" />
          <h3 className="text-xl font-medium text-slate-900" data-id="element-72">
            Gracias por tomar acción.
          </h3>
          <p className="text-slate-600 leading-relaxed" data-id="element-73">
            Las personas que obtienen resultados no son las que saben más, sino
            las que ejecutan con claridad.
          </p>
          <p className="font-bold text-indigo-900 text-lg" data-id="element-74">
            Nos vemos en la llamada.
          </p>
        </section>
      </main>
    </div>;
}